import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useEffect } from 'react';
import { format_price_x100, is_paid_tariff } from './billing-utils';
import { Alert, Avatar, CardContent, CardHeader, } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { openTopupDialog } from './top-up-dialog/redux/actions';
import { pay, reset_yakassa_success_pay } from './redux/actions';
import { isAndroidApp } from 'utils';
import { usePartial } from 'shared/hooks/utils';
import { AccountBalanceWalletRounded } from '@mui/icons-material';
import * as S from 'console/billing/styles';
import { loadBillingInfo } from 'console/billing/balance-card/redux/actions';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { ColumnBox } from 'shared/components/containers';
const default_not_enough_text = (amount_x100, tariff_pro) => {
    if (amount_x100 === 0 || (isAndroidApp() && !tariff_pro)) {
        return 'Оплатить';
    }
    return `Оплатить ${format_price_x100(amount_x100)}`;
};
export const BillingPayButton = memo(function BillingPayButton(props) {
    const { price_x100, enough_text = 'Оплатить с баланса', not_enough_text = default_not_enough_text, pay_intent, onPreCheck, button_props, disabled, success_message, } = props;
    const { loading, error, data } = useAppSelector((state) => state.billing.pay);
    const balance_x100 = useAppSelector((state) => state.billing.state.data.balance_x100);
    const tariff_pro = useAppSelector(is_paid_tariff);
    const onPay = useAction(usePartial(pay, props.pay_intent));
    const onOpenTopup = useAction(openTopupDialog);
    const onEnoughPay = useCallback(() => {
        if (!onPreCheck || onPreCheck?.()) {
            onPay();
        }
    }, [onPreCheck, onPay]);
    const onNeedTopUp = useCallback(() => {
        if (!onPreCheck || onPreCheck?.()) {
            onOpenTopup({
                suggested_amount_x100: price_x100 - balance_x100,
                pay_intent,
            });
        }
    }, [onPreCheck, onOpenTopup, price_x100, balance_x100, pay_intent]);
    return (_jsxs(ColumnBox, { children: [balance_x100 >= price_x100 && (_jsx(LoadingButton, { fullWidth: true, loading: loading, onClick: onEnoughPay, variant: "contained", color: "primary", disabled: disabled, ...button_props, children: enough_text })), balance_x100 < price_x100 && (_jsx(LoadingButton, { fullWidth: true, loading: loading, onClick: onNeedTopUp, variant: "contained", color: "primary", disabled: disabled, ...button_props, children: not_enough_text(price_x100 - balance_x100, tariff_pro) })), error && _jsx(Alert, { severity: "error", children: error }), data?.yakassa_success_pay && (_jsx(Alert, { severity: "success", children: success_message ?? 'Оплата прошла успешно!' }))] }));
});
export const BillingPayCard = memo(function BillingPayCard(props) {
    const { pay_props, success_message, ...rest } = props;
    //Обновляем информацию о балансе
    const load_billing_info = useAction(loadBillingInfo);
    const reset_yakassa_state = useAction(reset_yakassa_success_pay);
    useEffect(() => {
        load_billing_info();
        return () => {
            reset_yakassa_state();
        };
    }, []);
    const balance_x100 = useAppSelector((state) => state.billing.state.data.balance_x100);
    const { data } = useAppSelector((state) => state.billing.pay);
    return (_jsxs(S.Card, { variant: "outlined", ...rest, children: [balance_x100 > 0 && (_jsx(CardHeader, { avatar: _jsx(Avatar, { children: _jsx(AccountBalanceWalletRounded, {}) }), title: `Доступный баланс: ${format_price_x100(balance_x100)}`, titleTypographyProps: { variant: 'h6' } })), _jsx(CardContent, { children: _jsx(BillingPayButton, { ...pay_props, success_message: success_message, disabled: data?.yakassa_success_pay ?? false }) })] }));
});
